import { ApiConfigService } from './api-config.service';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../environments/environment-wrapper';
import { APP_CONFIG } from '../../app-config.constants';
import { IAppConfig } from '../../app-config.interface';
@Injectable()
export class BrowserApiConfigService extends ApiConfigService {

    private serverExceptions: { [key: string]: boolean; } = {};

    getServerRoot(route: string): string {

        return this.serverExceptions[route] ? environment.baseServerUrl : environment.cdnServerUrl;
    }
    constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig) {

        super();
        // On browser, use cdn for all except some exceptions
        this.serverExceptions[this.appConfig.urls.listings.provinceCity] = true;
        this.serverExceptions[this.appConfig.urls.listings.gallery] = true;
        this.serverExceptions[this.appConfig.urls.listings.active] = true;
        this.serverExceptions[this.appConfig.urls.listings.offmarket] = true;
        this.serverExceptions[this.appConfig.urls.listings.search] = true;
        this.serverExceptions[this.appConfig.urls.listings.distance] = true;
        this.serverExceptions[this.appConfig.urls.listings.filters] = true;
        this.serverExceptions[this.appConfig.urls.listings.addPageView] = true;

        this.serverExceptions[this.appConfig.urls.agent.search] = true;
        this.serverExceptions[this.appConfig.urls.agent.filters] = true;

        this.serverExceptions[this.appConfig.urls.office.searchByDistance] = true;
        this.serverExceptions[this.appConfig.urls.office.search] = true;

        this.serverExceptions[this.appConfig.urls.geo.base] = true;

        this.serverExceptions[this.appConfig.urls.demographics.neighbourhoodPoint] = true;

        // deal with CORS issues that occurs on local host with the blog
        if (environment.isLocal) this.serverExceptions[this.appConfig.urls.blog.base] = true;
    }


}
